import * as React from 'react';
import { Responsive } from '@cian/ui-kit';
import { throttle } from '@cian/newbuilding-utils';

import { FixedBlock } from '../FixedBlock';
import { HEADER_HIDE_ZONE, STICKY_HEADER_TOP } from '../../constants/elements';
import { Header, IHeaderProps } from '../Header';

export const FixedHeader = (props: IHeaderProps): React.JSX.Element => {
  const [isHeaderFixed, setHeaderFixed] = React.useState(false);

  const fixHeader = () => {
    const yOffser = window.scrollY;
    if (yOffser > HEADER_HIDE_ZONE) {
      setHeaderFixed(true);
    } else if (yOffser < HEADER_HIDE_ZONE) {
      setHeaderFixed(false);
    }
  };

  const onScrollHandler = throttle(50, fixHeader);

  React.useEffect(() => {
    fixHeader();
    window.addEventListener('scroll', onScrollHandler, false);

    return () => {
      window.removeEventListener('scroll', onScrollHandler, false);
    };
  }, [onScrollHandler]);

  return (
    <Responsive desktop>
      <FixedBlock top={isHeaderFixed ? 0 : -STICKY_HEADER_TOP}>
        <Header {...props} />
      </FixedBlock>
    </Responsive>
  );
};
